export default {
  getProductList: state => state.productList,
  getProductDetails: state => state.productDetails,
  getCustomAttributes: state => state.custom_attributes,
  getAttributes: state => state.attributes,
  getWhitelist: state => state.whitelist
}
